var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as Sentry from '@sentry/browser';
import { Injectable } from '@angular/core';
import { IonicErrorHandler } from 'ionic-angular';
import { UserProvider } from './../user/user';
let ErrorReportingProvider = ErrorReportingProvider_1 = class ErrorReportingProvider {
    constructor(userService) {
        this.userService = userService;
        this.ignoreErrorUrls = [/https:\/\/maps\.googleapis\.com/];
        this.ignoreErrorMessages = ['Error Code: 401'];
    }
    init() {
        Sentry.init({
            dsn: ErrorReportingProvider_1.SENTRY_DSN,
            release: ErrorReportingProvider_1.SENTRY_RELEASE,
            beforeSend: data => this.stripPathsFromData(data),
            blacklistUrls: this.ignoreErrorUrls,
            ignoreErrors: this.ignoreErrorMessages,
        });
        this.userService.currentUser$.subscribe(user => {
            this.setUserContext(user);
        });
    }
    stripPathsFromData(data) {
        if (data.culprit) {
            data.culprit = data.culprit.substring(data.culprit.lastIndexOf('/'));
        }
        const stacktrace = data.stacktrace ||
            (data.exception && data.exception.values[0].stacktrace);
        if (stacktrace) {
            stacktrace.frames.forEach(function (frame) {
                frame.filename = frame.filename.substring(frame.filename.lastIndexOf('/'));
            });
            if (data.stacktrace) {
                data.stacktrace = stacktrace;
            }
            else {
                data.exception.values[0].stacktrace = stacktrace;
            }
        }
        return data;
    }
    setUserContext(user) {
        if (user) {
            Sentry.configureScope(scope => {
                scope.setUser({
                    id: user.uid,
                    email: user.email,
                });
            });
        }
        else {
            Sentry.configureScope(scope => scope.clear());
        }
    }
};
ErrorReportingProvider.SENTRY_DSN = process.env.SENTRY_DSN ||
    'https://aea728c2696c4d08aa2d5c4800d5a299@sentry.io/5170091';
ErrorReportingProvider.SENTRY_RELEASE = process.env.SENTRY_RELEASE;
ErrorReportingProvider = ErrorReportingProvider_1 = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [UserProvider])
], ErrorReportingProvider);
export { ErrorReportingProvider };
export class YoshiErrorHandler extends IonicErrorHandler {
    handleError(error) {
        super.handleError(error);
        try {
            Sentry.captureException(error.originalError || error);
        }
        catch (e) {
            console.error(e);
        }
    }
}
var ErrorReportingProvider_1;
//# sourceMappingURL=error-reporting.js.map


// WEBPACK FOOTER //
// ./src/providers/error-reporting/error-reporting.ts.pre-build-optimizer.js